import {useEffect, useRef} from 'react';


const usePrevious = <T>(value: T): T | null => {
  const ref = useRef(null);
  useEffect(() => {
    // @ts-expect-error - TS2322 - Type 'T' is not assignable to type 'null'.
    ref.current = value;
  }, [value]);
  return ref.current;
};

export default usePrevious;
